import { Dispatch } from "redux";
import format from "date-fns/format";
import { isFulfilled, isRejected } from "@utils/promise-util";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { SERVER_DATE_FORMAT } from "@constants/date-formats";
import { ServiceOffering } from "@idw-types/data/reference-data/generic";
import { setWorkflowUsageDetailsSearchResults, setWorkflowUsageDetailsSearchResultsLoading } from "@redux/actions/workflow-usage-details-actions";
import { getWorkflowSankeyResultsRequest } from "@requests/reports/get-workflow-sankey-results";
import { getWorkflowResultsDetailsRequest } from "@requests/reports/get-workflow-results-details";
import { formatWorkflowResultsDetailsResponse } from "@formatters/workflow-results-details/workflow-results-details-formatter";
import { generateQueryParameters } from "@utils/query-parameter-util";

export const getWorkflowUsageDetailsSearchResultsReduxRequest = (dispatch: Dispatch) => async (
    rpServiceId: string,
    workflowId: string,
    startDate: Date,
    endDate: Date,
    serviceOfferings: Array<ServiceOffering>
) => {
    dispatch(setWorkflowUsageDetailsSearchResultsLoading(true));

    const queryParameters = generateQueryParameters({
        rpAXNServiceID: rpServiceId,
        workflowID: workflowId,
        dateCreatedStartDate: format(startDate, SERVER_DATE_FORMAT),
        dateCreatedEndDate: format(endDate, SERVER_DATE_FORMAT),
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        dateFormat: SERVER_DATE_FORMAT
    });

    const [workflowSankeyResults, workflowResultsDetails] = await Promise.allSettled([
        getWorkflowSankeyResultsRequest(queryParameters),
        getWorkflowResultsDetailsRequest(queryParameters)
    ]);

    let workflowSankeyResultsData = null;
    if (isFulfilled(workflowSankeyResults)) {
        if (workflowSankeyResults.value.data) {
            workflowSankeyResultsData = workflowSankeyResults.value.data;
        } else if (workflowSankeyResults.value.error) {
            logAndDisplayErrorModal(
                dispatch,
                workflowSankeyResults.value.error,
                resources.requests.getWorkflowSankeyResults.error.title,
                resources.requests.getWorkflowSankeyResults.error.message,
                null,
                queryParameters
            );
        }
    } else if (isRejected(workflowSankeyResults)) {
        logAndDisplayErrorModal(
            dispatch,
            workflowSankeyResults.reason,
            resources.requests.getWorkflowSankeyResults.error.title,
            resources.requests.getWorkflowSankeyResults.error.message,
            null,
            queryParameters
        );
    }

    let workflowResultsDetailsData = null;
    if (isFulfilled(workflowResultsDetails)) {
        if (workflowResultsDetails.value.data) {
            workflowResultsDetailsData = formatWorkflowResultsDetailsResponse(workflowResultsDetails.value.data, serviceOfferings);
        } else if (workflowResultsDetails.value.error) {
            logAndDisplayErrorModal(
                dispatch,
                workflowResultsDetails.value.error,
                resources.requests.getWorkflowResultsDetails.error.title,
                resources.requests.getWorkflowResultsDetails.error.message,
                null,
                queryParameters
            );
        }
    } else if (isRejected(workflowResultsDetails)) {
        logAndDisplayErrorModal(
            dispatch,
            workflowResultsDetails.reason,
            resources.requests.getWorkflowResultsDetails.error.title,
            resources.requests.getWorkflowResultsDetails.error.message,
            null,
            queryParameters
        );
    }

    dispatch(setWorkflowUsageDetailsSearchResults({
        workflowSankeyResults: workflowSankeyResultsData,
        workflowResultsDetails: workflowResultsDetailsData
    }));
};